module.exports = __webpack_public_path__ + "img/leiterinnen_johanna-pichler.342a8fa8.png";